<template>
  <div class="pb-50 pt-50 authenticate" style="margin: auto; max-width: 1346px">
    <div>
      <h3>{{ $t("users.resetPassword.title") }}</h3>
    </div>
    <el-row class="reset-wrapper">
      <el-col
        class="text-left bg-accent-light login-form-wrapper"
        :xs="24"
        :sm="24"
        :md="12"
      >
        <el-col class="bg-accent-light" :xs="24" :sm="24" :md="18">
          <div class="rectangle bg-accent-light text-left p-20">
            <el-form
              ref="resetpwdForm"
              :model="resetPassword"
              :rules="authRules"
            >
              <el-form-item prop="confirmPassword" class="mb-10">
                <el-input
                  :type="confirmPasswordInputType"
                  class="show-password"
                  v-model="resetPassword.confirmPassword"
                  :placeholder="$t('users.label.oldPassword')"
                >
                  <img
                    slot="suffix"
                    :src="eyeSolid"
                    v-if="confirmPasswordInputType === 'password'"
                    class="el-input__icon password-icon-class"
                    @click="changesConfirmPasswordInputType('text')"
                  />
                  <img
                    slot="suffix"
                    :src="eyeSlashSolid"
                    v-else
                    class="el-input__icon password-icon-class"
                    @click="changesConfirmPasswordInputType('password')"
                  />
                </el-input>
              </el-form-item>
              <el-form-item prop="password" class="mb-10">
                <el-input
                  :type="passwordInputType"
                  class="show-password"
                  v-model="resetPassword.password"
                  :placeholder="$t('users.label.newPassword')"
                >
                  <img
                    slot="suffix"
                    :src="eyeSolid"
                    v-if="passwordInputType === 'password'"
                    class="el-input__icon password-icon-class"
                    @click="changesPasswordInputType('text')"
                  />
                  <img
                    slot="suffix"
                    :src="eyeSlashSolid"
                    v-else
                    class="el-input__icon password-icon-class"
                    @click="changesPasswordInputType('password')"
                  />
                </el-input>
              </el-form-item>
              <div :class="[isModal ? 'text-left' : 'text-center mt-15']">
                <el-button
                  type="primary"
                  native-type="submit"
                  class="forgot-submit mt-15"
                  @click="handlePassReset"
                >
                  {{ $t("users.forgotPasswordModal.button") }}
                </el-button>
              </div>
            </el-form>
          </div>
        </el-col>
      </el-col>
    </el-row>
  </div>
</template>
  
  <script>
import imgConfirmationSuccess from "@/assets/images/confirmation-success.svg";
import eyeSlashSolid from "@/assets/images/icons/password/eye-slash-solid.svg";
import eyeSolid from "@/assets/images/icons/password/eye-solid.svg";
import userApi from "@/api/user";
import { mapState } from 'vuex';

export default {
  components: {},
  props: {},
  computed:{
    ...mapState("user", ["user"]),
  },
  data() {
    return {
        resetPassword :{
            password: null,
            confirmPassword: null,
        },
      registerConfirmation: false,
      images: {
        confirmationSuccess: {
          src: imgConfirmationSuccess,
        },
      },
      eyeSolid: eyeSolid,
      eyeSlashSolid: eyeSlashSolid,
      passwordInputType: "password",
      confirmPasswordInputType: "password",
      isModal:false,
      authRules: {
        password: [
          {
            required: true,
            message: this.$i18n.t("checkout.from.password"),
            trigger: "blur",
          },
        ],
        confirmPassword: [
          {
            required: true,
            message: this.$i18n.t("checkout.from.password"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    showConfirmation() {
      this.registerConfirmation = true;
    },
    changesPasswordInputType(type) {
      this.passwordInputType = type;
    },
    changesConfirmPasswordInputType(type) {
      this.confirmPasswordInputType = type;
    },
    handlePassReset(e) {
        e.preventDefault();
        const user = localStorage.getItem("user");
        const account = JSON.parse(user);
        const vm = this;
        if(account && account.id) {
          this.$refs.resetpwdForm.validate().then((valid) => {
            if (valid) {
               userApi
                .updateUserPassword(account.id, {
                  oldPassword: vm.resetPassword.confirmPassword,
                  newPassword: vm.resetPassword.password,
                })
                .then(() => {
                  // this.$emit("emit-password-update");
                  this.$router.push('/account');
                })
                .catch((error) => {
                  vm.$emit("error", error);
                });
            }
          });
        }
      },
  },
};
</script>
  
  <style scoped>
.rectangle {
  min-height: 420px;
  box-sizing: border-box;
  font-family: 'Futura Std', 'Futura Std', sans-serif;
  color: #333333;
  text-align: center;
  line-height: normal;
  padding-top: 40px;
  margin-bottom: 30px;
  text-align: left;
  letter-spacing: 0.5px;
  margin-right: 30px;
  margin-left: 30px;
}
.connexion {
  width: 93px;
  height: 24px;
  background-color: rgba(255, 255, 255, 0);
  box-sizing: border-box;
  font-family: "Futura Std ", "Futura Std", sans-serif;
  font-weight: bold;
  color: #333333;
  text-align: left;
  line-height: normal;
  letter-spacing: 0.25px;
  margin-bottom: 18px;
  font-size: 18px;
}
.confirmation-logo {
  float: left;
  margin-right: 10px;
}

h4 {
  float: left;
}
.login-form-wrapper,
.reset-wrapper {
  display: flex;
  justify-content: center;
}
.el-input__icon.password-icon-class{
  cursor: pointer !important;
}
.el-input__inner {
  letter-spacing: 1px !important;
}
</style>